import { jsx } from 'react/jsx-runtime';
import { useSwitch } from '../../Switch.hooks.js';
import { Slot } from '../Slot/Slot.js';

function LeftSlot(props) {
  const {
    checked
  } = useSwitch();
  // When using both left and right slots, the latter will always be considered as the "correct" or "ON" value.
  return jsx(Slot, {
    ...props,
    checked: !checked
  });
}

export { LeftSlot };
